'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import Alert from 'react-bootstrap/Alert';
import {isEmpty} from '@uw-it-sis/lib-react/lib/Utils';
import TermUtils from '@uw-it-sis/lib-react/lib/TermUtils';
import { Link } from 'react-router-dom';
import { sprintf } from 'sprintf-js';
import { stringify } from 'qs';

/**
 * Navigation between multiple versions of a course.
 */
const CourseVersions = (props) => {

    let component = null;

    // Check to see if there is any version data
    if (! isEmpty(props.version)) {
        let message = [];
        let type = null;

        // Build a short array of the published term ids
        let terms =  props.publishedTerms.map(function (term) {
            return term.id;
        });

        let currentVersion = props.version;

        // Need to display message if only one version, but course is new or expiring.
        if (currentVersion.nextTermId === null && currentVersion.prevTermId === null) {
            // Only if the startTerm of this course version exists in the published terms we need to add the "effective from" message.
            if (terms.indexOf(props.startTerm) !== -1) {
                message = [
                    <span key={0}>
                        {sprintf("These course details are effective beginning %s.", TermUtils.makeTermDescriptionFromTermId(props.startTerm, 'LONG'))}
                    </span>
                ];
                type = 'info';
            }
            // Only if the endTerm of this course version exists in the published terms we need to add the "expiring in" message.
            if (terms.indexOf(props.endTerm) !== -1) {
                message = [
                    <span key={0}>
                        {sprintf("These course details are effective through %s.", TermUtils.makeTermDescriptionFromTermId(props.endTerm, 'LONG'))}
                    </span>
                ];
                type = 'warning';
            }
        }

        // This covers the three version of courses available and we are viewing the middle course version, where it will have prev and next versions.
        else if (currentVersion.nextTermId != null && currentVersion.prevTermId != null) {
            let queryString = stringify({id: currentVersion.prevCourseId}, { addQueryPrefix: true });
            message = [
                <span key={0}>{sprintf(
                    "These course details are effective beginning %s through %s. ",
                    TermUtils.makeTermDescriptionFromTermId(currentVersion.prevTermId, 'LONG'),
                    TermUtils.makeTermDescriptionFromTermId(currentVersion.nextTermId, 'LONG')
                )}</span>,
                <Link key={1} to={{ pathname: '/courses/' + props.courseCode, search: queryString }}>View previous version</Link>,
                <Link key={2} to={{ pathname: '/courses/' + props.courseCode, search: queryString }}>View new version</Link>
            ];
            type = 'info';
        }

        // This covers the scenario with two course versions and this course version is expiring and there is a new version available.
        else if (currentVersion.nextTermId != null && currentVersion.prevTermId === null) {
            let queryString = stringify({id: currentVersion.nextCourseId}, { addQueryPrefix: true });
            message = [
                <span key={0}>{sprintf("These course details are effective through %s. ", TermUtils.makeTermDescriptionFromTermId(currentVersion.termId, 'LONG'))}</span>,
                <Link key={1} to={{ pathname: '/courses/' + props.courseCode, search: queryString }}>View new version</Link>
            ];
            type = 'warning';
        }

        //This covers the scenario with two course versions and this course version is a new version and there is a old version available.
        else if (currentVersion.nextTermId === null && currentVersion.prevTermId != null) {
            let queryString = stringify({id: currentVersion.prevCourseId}, { addQueryPrefix: true });
            message = [
                <span key={0}>{sprintf("These course details are effective beginning %s. ", TermUtils.makeTermDescriptionFromTermId(currentVersion.termId, 'LONG'))}</span>,
                <Link key={1} to={{ pathname: '/courses/' + props.courseCode, search: queryString }}>View previous version</Link>
            ];
            type = 'info';
        }

        if (message.length) component = <Alert variant={type}>{message}</Alert>;
    }

    return component;

};

CourseVersions.propTypes = {
    courseCode: PropTypes.string.isRequired,
    // An object containing version metadata.
    version: PropTypes.object.isRequired,
    publishedTerms: PropTypes.array,
    startTerm: PropTypes.string,
    endTerm: PropTypes.string
};

export default CourseVersions;